export default "__VITE_ASSET__D1CECiDa__"